import React, { createContext, useContext } from "react";

interface FolderContextType {
  selectedFolderId: string | null;
  isInFolderContext: boolean; // New flag to detect nesting
}

const FolderContext = createContext<FolderContextType | undefined>(undefined);

export const useFolderContext = () => {
  const context = useContext(FolderContext);
  if (context === undefined) {
    // Return default context when not inside a FolderProvider
    return { selectedFolderId: null, isInFolderContext: false };
  }
  return context;
};

interface FolderProviderProps {
  selectedFolderId: string | null;
  children: React.ReactNode;
}

export const FolderProvider: React.FC<FolderProviderProps> = ({
  selectedFolderId,
  children,
}) => {
  const value = {
    selectedFolderId,
    isInFolderContext: true, // Mark that we're in a folder context
  };

  return (
    <FolderContext.Provider value={value}>{children}</FolderContext.Provider>
  );
};